/* eslint-disable */
module.exports = {
  formatDate: (date) => {
    var date = new Date(date);
    var YY = date.getFullYear() + '-';
    var MM = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
    var DD = (date.getDate() < 10 ? '0' + (date.getDate()) : date.getDate());
    var hh = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
    var mm = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
    var ss = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
    return YY + MM + DD +" "+hh + mm + ss;
  },
  memberType: (type) => {
    switch (parseInt(type)) {
      case 0:
        return '申请人'
      case 1:
        return '被申请人'
      case 2:
        return '仲裁员'
      case 3:
        return '秘书'
      case 4:
        return '证人'
      case 5:
        return '申请人代理人'
      case 6:
        return '被申请人代理人'
      case 7:
        return '翻译员'
      case 8:
        return '鉴定员'
      case 9:
        return '其他'
      case 10:
        return '超管'
    }
  },
  memberSort: (type) => {
    switch (parseInt(type)) {
      case 0:
        return 2
      case 1:
        return 3
      case 2:
        return 0
      case 3:
        return 1
      case 4:
        return 6
      case 5:
        return 4
      case 6:
        return 5
      case 7:
        return 7
      case 8:
        return 8
      case 9:
        return 9
      case 10:
        return 10
    }
  }
}
